import { render, staticRenderFns } from "./ad-list.vue?vue&type=template&id=72e8b5ac&scoped=true&"
import script from "./ad-list.vue?vue&type=script&lang=js&"
export * from "./ad-list.vue?vue&type=script&lang=js&"
import style0 from "./ad-list.vue?vue&type=style&index=0&id=72e8b5ac&lan=less&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e8b5ac",
  null
  
)

component.options.__file = "ad-list.vue"
export default component.exports